import { CaseGranulometry } from '../../CaseGranulometry';
import { Property } from '../../../../specification/cases/Property';

export const getCaseProperty = (
  caseGranulometry: CaseGranulometry,
  propertyName: string
): Property | undefined => {
  return caseGranulometry.properties?.find((property) => property?.name === propertyName);
};
